import type { QueryWhereValue } from './query-params';

export interface PageParam {
    offset: number;
}

export interface PageResult<T> {
    rows: T[];
    total: number;
    offset: number;
    limit: number;
}

export interface PagedQueryArg {
    limit: number;
    order?: Array<[field: string, dir: 'ASC' | 'DESC']>;
    where?: Record<string, QueryWhereValue>;
    /** Top-level query params appended outside of `where` (e.g. tenantId). */
    extraParams?: Record<string, string>;
}

export interface PagedMetaEnvelope {
    total?: number;
    offset?: number;
    limit?: number;
}

export const DEFAULT_PAGE_SIZE = 180;
